import * as endpoints from './endpoints';

const PatientService = {
  ...endpoints,
};

export default PatientService;
export type {
  PatientRosterRow,
  PatientDetails,
  PatientRecord,
  MeasureSummary,
  MeasureReading,
  MeasureReadingsResult,
  ProgramNote,
  ProgramNoteAuthor,
  ProgramNoteListResult,
} from './endpoints';
